import React, { useContext } from 'react'
import { ModalContext } from 'containers/ModalManager'
import RenameShareModal from 'containers/modals/RenameShareModal'

import Dropdown from 'components/Dropdown'

interface RenameActionProps {
  id: string
  name: string
}

const RenameAction: React.FC<RenameActionProps> = ({ id, name, children }) => {
  const { showModal } = useContext(ModalContext)

  return (
    <Dropdown.Item
      onClick={() => {
        showModal(RenameShareModal, {
          id,
          name,
        })
      }}>
      {children}
    </Dropdown.Item>
  )
}

export default RenameAction
